import { Navigate, Route, Routes } from "react-router";

import AuthorizedRoute from "../components/Routes/AuthorizedRoutes";

import SvarUtBrevHistorikk from "../components/Common/Detalj/SvarUtBrevhistorikk";
import IleggelseOrginalbilde from "../components/Common/Ileggelser/Detalj/IleggelseOrginalbilde";
import IleggelseImageEditorPageContainer from "../components/Common/Ileggelser/Detalj/ImageEditorPageContainer";
import IleggelseDetaljPage from "../components/Ileggelse/Detalj/IleggelseDetaljPage";
import AArsrapportPage from "../components/Rapporter/AArsrapport/AArsrapportPage";
import AntallIleggelserPerIleggelsetypePage from "../components/Rapporter/AntallIleggelserPerIleggelsetype/AntallIleggelserPerIleggelsetypePage";
import KlagerapportPage from "../components/Rapporter/Klagerapport/KlagerapportPage";
import MakuleringerPage from "../components/Rapporter/Makuleringer/MakuleringerPage";
import PiggdekkontrollPage from "../components/Rapporter/Piggdekkontroll/PiggdekkontrollPage";
import SkiftloggPage from "../components/Rapporter/Skiftlogg/SkiftloggPage";
import UbetalteIleggelserDetaljPage from "../components/Rapporter/UbetalteIleggelser/Detalj/UbetalteIleggelserDetaljPage";
import UbetalteIleggelserPage from "../components/Rapporter/UbetalteIleggelser/UbetalteIleggelserPage";
import UferdigstilteKlagesakerPage from "../components/Rapporter/UferdigstilteKlagesaker/UferdigstilteKlagesakerPage";
import VentilstillingBildevisning from "../components/Rapporter/Ventilstilling/VentilstillingBildevisning";
import VentilstillingPage from "../components/Rapporter/Ventilstilling/VentilstillingPage";
import VentilstillingsdetailUtskriftPage from "../components/Rapporter/Ventilstilling/VentilstillingsdetailUtskriftPage";
import VentilstillingsdetaljPage from "../components/Rapporter/Ventilstilling/VentilstillingsdetaljPage";

import {
    bypatruljen,
    bypatruljenAll,
    juridisk,
    juridiskAll,
    skiftlogg,
} from "../constants/roles";
import sitePath from "../constants/sitePaths";
import { getRedirectPath } from "../utils/pathnameUtils";

// Role groups
const ALL = [...Object.values(bypatruljen), ...Object.values(juridisk)];
const SVAT = [
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  juridisk.ledelse,
  juridisk.saksbehandler,
];
const EDIT = [
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
  juridisk.saksbehandler,
];
const UBETALT = [
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
  bypatruljen.seksjonssjefStab,
];
const UFERDIG = [
  ...juridiskAll,
  bypatruljen.avdelingdirektor,
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
];
const KLAGE_R = [
  juridisk.ledelse,
  bypatruljen.saksbehandler,
  bypatruljen.saksbehandleradmin,
  bypatruljen.avdelingdirektor,
  bypatruljen.seksjonssjefStab,
];
const MAKULER = [
  bypatruljen.avdelingdirektor,
  bypatruljen.seksjonssjefStab,
  bypatruljen.saksbehandleradmin,
  bypatruljen.saksbehandler,
];

const Rapporter = () => (
  <Routes>
    {/* piggdekkontroller */}
    <Route path="piggdekkontroller">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute
            roles={[...Object.values(bypatruljen), ...juridiskAll]}
          >
            <PiggdekkontrollPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* ventilstillinger */}
    <Route path="ventilstillinger">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={ALL}>
            <VentilstillingPage />
          </AuthorizedRoute>
        }
      />
      <Route path=":id">
        <Route
          index
          element={
            <AuthorizedRoute roles={ALL}>
              <VentilstillingsdetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path="bilder/:bildeId"
          element={
            <AuthorizedRoute roles={ALL}>
              <VentilstillingBildevisning />
            </AuthorizedRoute>
          }
        />
        <Route
          path="utskrift"
          element={
            <AuthorizedRoute roles={ALL}>
              <VentilstillingsdetailUtskriftPage />
            </AuthorizedRoute>
          }
        />
        {/* ileggelse detalj reached from within a ventilstilling detalj page */}
        <Route
          path="ileggelse/:id"
          element={
            <AuthorizedRoute roles={ALL}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path="ileggelse/:id/bilder/:bildeId"
          element={
            <AuthorizedRoute roles={ALL}>
              <IleggelseOrginalbilde />
            </AuthorizedRoute>
          }
        />
        <Route
          path="ileggelse/:id/bilder/:bildeId/rediger"
          element={
            <AuthorizedRoute roles={EDIT}>
              <IleggelseImageEditorPageContainer />
            </AuthorizedRoute>
          }
        />
        <Route
          path="ileggelse/:id/svar-ut/:svarUtId/historikk"
          element={
            <AuthorizedRoute roles={SVAT}>
              <SvarUtBrevHistorikk />
            </AuthorizedRoute>
          }
        />
      </Route>
      {/* ileggelse detalj reached directly from ventilstillinger list */}
      <Route
        path="ileggelse/:id"
        element={
          <AuthorizedRoute roles={ALL}>
            <IleggelseDetaljPage />
          </AuthorizedRoute>
        }
      />
      <Route
        path="ileggelse/:id/bilder/:bildeId"
        element={
          <AuthorizedRoute roles={ALL}>
            <IleggelseOrginalbilde />
          </AuthorizedRoute>
        }
      />
      <Route
        path="ileggelse/:id/bilder/:bildeId/rediger"
        element={
          <AuthorizedRoute roles={EDIT}>
            <IleggelseImageEditorPageContainer />
          </AuthorizedRoute>
        }
      />
      <Route
        path="ileggelse/:id/svar-ut/:svarUtId/historikk"
        element={
          <AuthorizedRoute roles={SVAT}>
            <SvarUtBrevHistorikk />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* skiftlogg */}
    <Route path="skiftlogg">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={[skiftlogg, ...Object.values(bypatruljen)]}>
            <SkiftloggPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* klager */}
    <Route path="klager">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={KLAGE_R}>
            <KlagerapportPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* ubetalte-ileggelser */}
    <Route path="ubetalte-ileggelser">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={UBETALT}>
            <UbetalteIleggelserPage />
          </AuthorizedRoute>
        }
      />
      <Route path=":kjoretoyId">
        <Route
          index
          element={
            <AuthorizedRoute roles={UBETALT}>
              <UbetalteIleggelserDetaljPage />
            </AuthorizedRoute>
          }
        />
        <Route
          path="ileggelser/:id"
          element={
            <AuthorizedRoute roles={UBETALT}>
              <IleggelseDetaljPage />
            </AuthorizedRoute>
          }
        />
      </Route>
    </Route>

    {/* uferdigstilte-klagesaker */}
    <Route path="uferdigstilte-klagesaker">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={UFERDIG}>
            <UferdigstilteKlagesakerPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* saksbehandler (juridiskSaksbehandler) */}
    <Route path="saksbehandler">
      <Route
        index
        element={
          <Navigate
            to={sitePath.rapporter.juridiskSaksbehandler.oversikt}
            replace
          />
        }
      />
    </Route>

    {/* antall-ileggelser-per-ileggelsetype */}
    <Route path="antall-ileggelser-per-ileggelsetype">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={[...bypatruljenAll, ...juridiskAll]}>
            <AntallIleggelserPerIleggelsetypePage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* makuleringer */}
    <Route path="makuleringer">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={MAKULER}>
            <MakuleringerPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    {/* aarsrapport */}
    <Route path="aarsrapport">
      <Route index element={<Navigate to="oversikt" replace />} />
      <Route
        path="oversikt"
        element={
          <AuthorizedRoute roles={[...bypatruljenAll, ...juridiskAll]}>
            <AArsrapportPage />
          </AuthorizedRoute>
        }
      />
    </Route>

    <Route
      index
      element={
        <Navigate to={getRedirectPath(sitePath.rapporter.shortUrl)} replace />
      }
    />
  </Routes>
);

export default Rapporter;
